import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach JWT for email/password auth + language preference
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers['X-Lang'] = localStorage.getItem('lang') || 'en';
  return config;
});

// While offline, swallow background fetch failures (SW returns 503 {offline:true}) so no crash overlay appears
api.interceptors.response.use((r) => r, (err) => {
  const offline = !navigator.onLine || err?.response?.data?.offline === true;
  if (offline) { const e = new Error('offline'); e.offline = true; e.response = err.response; return Promise.reject(e); }
  return Promise.reject(err);
});
window.addEventListener('unhandledrejection', (ev) => { if (ev.reason?.offline) ev.preventDefault(); });
